import React, { Component } from 'react'

class NotAuthorized extends Component {
  render () {
    return <div>Not Authorized</div>
  }
}

export default NotAuthorized
